import { render, staticRenderFns } from "./TableSupplier.vue?vue&type=template&id=007e0578"
import script from "./TableSupplier.vue?vue&type=script&lang=js"
export * from "./TableSupplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports